import { VenueCarouselItem } from "@punchup/data/models";
import { getCDNImageURL } from "@punchup/utils/getCDNImageURL";
import Image from "next/image";

interface Props {
  item: Extract<VenueCarouselItem, { type: "image" }>;
  previewUrl?: string;
}

export default function ImageCarouselItem({ item, previewUrl }: Props) {
  return (
    <div className="w-full">
      <div className="relative aspect-[16/9] rounded-lg overflow-hidden">
        <Image
          src={previewUrl ?? getCDNImageURL(item.image.imageId)}
          alt={item.image.altText ?? "carousel image"}
          fill
          className="object-cover"
        />
      </div>
    </div>
  );
}
